<template>
  <form target="_blank" action="https://formspree.io/f/xeoopyvb" method="POST" id="form-group" class="flex flex-col gap-2 justify-center" @submit="submitForm" v-if="!submitted">
    <div class="form-group">
        <div class="form-row">
            <div class="col flex flex-col gap-2">
                <label for="name" id="name" class="text-[#6a998f] text-lg m-0 leading-none">Full Name:</label>
                <input type="text" name="name" class="form-control" placeholder="Full Name" required>
            </div>
        </div>
    </div>
    <div class="form-group">
        <div class="col">
            <label for="email" id="email" class="text-[#6a998f] text-lg mb-0 leading-none">Email:</label>
            <input type="email" name="email" class="form-control" placeholder="Email Address" required>
        </div>
    </div>
    <div class="form-group">
        <label for="message" id="message" class="text-[#6a998f] text-lg mb-0 leading-none">Your Message:</label>
        <textarea placeholder="Your Message" class="form-control resize-none" name="message" rows="5" required></textarea>
    </div>
    <div class="flex flex-row items-start gap-4">
      <button type="submit" class="w-auto whitespace-nowrap">Submit Form</button>
      <button type="reset" class="w-auto whitespace-nowrap">Reset Form</button>
    </div>
  </form>
  <div class="relative w-full flex flex-col place-items-center gap-4" v-if="submitted">
    <span class="block font-normal text-lg">Thanks for sending your message!</span>
    <span class="block font-normal text-lg">I will respond as soon as possible</span>
    <button 
      class="w-auto whitespace-nowrap" 
      @click="emit('toggle-submitted')">
        Send Another Message
    </button>
  </div>
</template>
  
<script lang="ts" setup>
interface Props {
  submitted: boolean;
}
const props = defineProps<Props>();
const emit = defineEmits(['toggle-submitted']);

const submitForm = (): void => {
  setTimeout(() => {
    const formElement = document.getElementById('form-group') as HTMLFormElement;
    if (formElement) {
      formElement.reset(); 
    }
    emit('toggle-submitted', true);
  }, 500); 
};
</script>
  
<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@500;700&display=swap');

form {
  position: relative;
  width: 100%;
}

label {
  color: #6a998f;
  font-size: 18px;
}

input, textarea {
  width: 90%;
  padding: 8px;
  border: 1px solid #a8c3b4; 
  border-radius: 6px;
  background-color: #f0f7f2; 
  color: #4a6350;
  font-family: inherit;
}

button {
  padding: 10px 20px;
  background-color: #90b7a7; 
  width: auto;
  color: #ffffff;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  cursor: pointer;
  transition: background-color 0.2s ease-in-out;
}

button:hover {
  background-color: #6a998f; /* Darker green on hover */
}
</style>
